package com.islamicmedia.site.pages

import androidx.compose.runtime.*
import com.islamicmedia.shared.presentation.ProgressStatus
import com.islamicmedia.shared.presentation.ProgressStep
import com.islamicmedia.site.components.ProgressTracker
import com.islamicmedia.site.theme.*
import com.varabyte.kobweb.core.Page
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Page("/test")
@Composable
fun TestPage() {
    val dummySteps = listOf(
        ProgressStep(1, "Searching the web...", ProgressStatus.COMPLETED),
        ProgressStep(2, "Gathering content reviews...", ProgressStatus.COMPLETED),
        ProgressStep(3, "Checking parental guides...", ProgressStatus.SEARCHING),
        ProgressStep(4, "Reading community feedback...", ProgressStatus.SEARCHING),
        ProgressStep(5, "Analyzing against Islamic principles...", ProgressStatus.SEARCHING)
    )

    Div(attrs = {
        style {
            width(100.percent)
            minHeight(100.vh)
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
            property("background", GradientHeader)
            padding(20.px)
        }
    }) {
        Div(attrs = {
            style {
                width(100.percent)
                maxWidth(500.px)
            }
        }) {
            ProgressTracker(
                steps = dummySteps,
                progress = 0.5f,
                currentCost = 0.0,
                title = "Test Mode"
            )
        }
    }
}
